import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

const _rawAdminEmails = String(import.meta.env.VITE_ADMIN_EMAILS || "").trim();
const adminEmails = (
  _rawAdminEmails ? _rawAdminEmails : "admin@wow5050.org"
)
  .split(",")
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

const AuthContext = createContext({
  user: null,
  loading: true,
  isAdmin: false,
  adminEmails: [],
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAdmin = !!user?.email && adminEmails.includes(String(user.email).toLowerCase());

  useEffect(() => {
    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setUser(data?.session?.user ?? null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin, adminEmails }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
